/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes, { any } from 'prop-types';
import { Redirect, Route } from 'react-router-dom';

const PrivateRoute = ({ component: Component, prompt, ...rest }) => {
  const userDetails = JSON.parse(localStorage.getItem('studentDetails'));
  return (
    <Route
      {...rest}
      render={(props) => (
        userDetails
          ? (
            <>
              {prompt
                ? (<Component {...props} prompt={prompt} />)
                : (<Component {...props} />)}
            </>
          ) : (
            <Redirect
              to={{
                pathname: '/login',
              }}
              exact
            />
          )
      )}
    />
  );
};

export default PrivateRoute;

PrivateRoute.propTypes = {
  component: PropTypes.element,
  prompt: any,
};
